// constants
export const METHODS = {
	GET: "GET",
	POST: "POST",
	PUT: "PUT",
	DELETE: "DELETE",
};

export const DEFAULT_ERROR = {
	error: {
		message: "No error response",
		type: "DefaultError",
	},
};

export const NO_AJAX_LIB_ERROR = {
	error: {
		message: "Missing required files. Please refresh and try again.",
		type: "NoAjaxLibError",
	},
};

// Fallback for not having jQuery / Zepto in the global space
let axios = null;

if (process.env.PLATFORM === "mobile") {
	axios = require("axios");
}

if (!process.env.PLATFORM) {
	axios = require("axios");
}

// Return if they have jQuery or not
function getJquery() {
	if (!process.env.PLATFORM) {
		return null;
	}

	if (window.$ && window.$.ajax) {
		return window.$;
	} else if (window.jQuery && window.jQuery.ajax) {
		return window.jQuery;
	}

	return null;
}

function jqueryRequest(path, params, resolve, reject) {
	const $ = getJquery();
	let jqPath = path;

	const jqParams = {
		...params,
		type: params.type || METHODS.GET,
		dataType: "json",

		success: (res) => {
			if (res.error) {
				if (params.error) {
					params.error(res);
				}

				reject(params.error);
			}
			else {
				if (params.success) {
					params.success(res);
				}

				resolve(res);
			}
		},

		error: (res) => {
			let err = DEFAULT_ERROR;

			if (res.responseJSON) {
				// Don't do anything if the user aborted
				if (res.statusText === "abort") {
					return;
				}

				err = res.responseJSON;
			}

			if (params.error) {
				params.error(err, res);
			}

			reject(err, res);
		},
	};

	if (params.data) {
		if (params.type === METHODS.DELETE) {
			// jQuery doesn't auto-convert params for DELETE like it does for GET.
			jqPath = `${jqPath}?${$.param(params.data)}`;
			delete (jqParams.data);
		} else if (params.type === METHODS.POST || params.type === METHODS.PUT) {
			// For POST / PUT, the API speaks in json.
			jqParams.data = JSON.stringify(params.data);
			jqParams.contentType = "application/json; charset=UTF-8";
		}
	}

	$.ajax({
		url: jqPath,
		...jqParams,
	});
}

function axiosRequest(path, params, resolve, reject) {
	const method = params.type || METHODS.GET;
	let axiosData = null;
	let axiosParams = null;

	if (method === METHODS.PUT || method === METHODS.POST) {
		axiosData = params.data;
	}
	else {
		axiosParams = params.data;
	}

	axios({
		...params,
		method,
		url: path,
		data: axiosData,
		params: axiosParams,
	})
		.then((res) => {
		// Well now how did this happen...
			if (!res || !res.data) {
				throw new Error();
			}

			if (res.data.error) {
				if (params.error) {
					params.error(res.data, res);
				}

				reject(res.data, res);
			} else {
				if (params.success) {
					params.success(res.data);
				}

				resolve(res.data);
			}
		})
		.catch((error) => {
			let err = DEFAULT_ERROR;

			if (error.response && error.response.data) {
				err = error.response.data;
			}

			if (params.error) {
				params.error(err, error.response);
			}

			reject(err, error.response);
		});
}

export default function ajax(path, params) {
	// Desktop / app have jquery / zepto respectively
	return new Promise((resolve, reject) => {
		if (getJquery()) {
			jqueryRequest(path, params, resolve, reject);
		}

		else if (axios) {
			// But fallback to axios for mobile web, or if apps change
			axiosRequest(path, params, resolve, reject);
		}

		else {
			// Worst case, still fail gracefully
			if (params.error) {
				params.error(NO_AJAX_LIB_ERROR, 0);
			}

			reject(NO_AJAX_LIB_ERROR, 0);
		}
	});
}




// WEBPACK FOOTER //
// ./src/shared/util/ajax.js